<template>
  <form class="flex items-center" @submit.prevent>
    <label for="search-input" class="sr-only">Search</label>

    <div class="relative w-full">
      <!-- Search icon -->
      <div
        class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
      >
        <svg
          class="w-4 h-4 text-muted dark:text-muted-light"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      <input
        id="search-input"
        type="text"
        :placeholder="placeholder"
        @input="search"
        autocomplete="off"
        spellcheck="false"
        class="w-full pl-9 pr-4 py-2 rounded-xl text-[13px] font-medium
               bg-primary-50 dark:bg-dark-600
               border border-primary-100 dark:border-dark-500
               text-dark-700 dark:text-white
               placeholder-muted dark:placeholder-muted-light
               outline-none transition-all duration-200
               focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20
               dark:focus:border-primary-400"
      />
    </div>
  </form>
</template>

<script>
export default {
  name: "SearchForm",

  props: {
    placeholder: {
      type: String,
      default: "Search event...",
    },
  },

  emits: ["search"],

  setup(props, { emit }) {
    const search = (e) => {
      emit("search", e.target.value);
    };

    return {
      search,
    };
  },
};
</script>